// Popular Destinations Section - Quick links to destinations
const PopularDestinationsSection = () => {
  const destinations = [
    { name: "Marbella", slug: "marbella", time: "45 min", highlight: true },
    { name: "Puerto Banús", slug: "puerto-banus", time: "50 min", highlight: true },
    { name: "Estepona", slug: "estepona", time: "70 min" },
    { name: "Fuengirola", slug: "fuengirola", time: "25 min" },
    { name: "Torremolinos", slug: "torremolinos", time: "15 min" },
    { name: "Benalmádena", slug: "benalmadena", time: "20 min" },
    { name: "Mijas", slug: "mijas", time: "35 min" },
    { name: "Nerja", slug: "nerja", time: "45 min" }
  ];

  const scrollToDestination = (slug) => {
    const element = document.getElementById(`destino-${slug}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-12 sm:py-16 px-4 bg-[#0a0a14]" data-testid="popular-destinations">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <p className="section-subtitle">
            <i className="fas fa-map-marked-alt mr-2"></i>
            Destinos Populares
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: "'Cinzel', serif" }}>
            Transfer desde <span className="gradient-text">Aeropuerto Málaga</span>
          </h2>
          <p className="text-gray-400 mt-3 max-w-2xl mx-auto">
            Servicio privado con conductor. Precio cerrado sin sorpresas. Selecciona tu destino:
          </p>
        </div>

        {/* Destinations Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {destinations.map((dest) => (
            <button
              key={dest.slug}
              onClick={() => scrollToDestination(dest.slug)}
              className={`group glass rounded-xl p-4 sm:p-5 text-left transition-all hover:border-[#c9a962] border border-transparent ${
                dest.highlight ? 'ring-1 ring-[#c9a962]/30' : ''
              }`}
              data-testid={`dest-link-${dest.slug}`}
            >
              <div className="flex items-start justify-between mb-2">
                <h3 className="font-semibold text-white group-hover:text-[#c9a962] transition-colors" style={{ fontFamily: "'Cinzel', serif" }}>
                  {dest.name}
                </h3>
                {dest.highlight && (
                  <span className="bg-[#c9a962]/20 text-[#c9a962] text-[10px] px-2 py-0.5 rounded-full font-semibold">
                    TOP
                  </span>
                )}
              </div>
              <p className="text-xs text-gray-500 flex items-center gap-1">
                <i className="fas fa-clock text-[#c9a962]"></i>
                {dest.time}
              </p>
              <p className="text-xs text-[#c9a962] mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                Ver detalles <i className="fas fa-arrow-down ml-1"></i>
              </p>
            </button>
          ))}
        </div>

        {/* Quick CTA */}
        <div className="text-center mt-8">
          <p className="text-gray-400 text-sm mb-4">
            ¿No encuentras tu destino? Escríbenos y te damos precio al momento
          </p>
          <a
            href="https://wa.me/34600221794?text=Hola%20quiero%20precio%20para%20traslado%20desde%20aeropuerto%20M%C3%A1laga%20a%20"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#128C7E] text-white font-bold py-3 px-6 rounded-xl transition-all"
          >
            <i className="fab fa-whatsapp text-xl"></i>
            Consultar otro destino
          </a>
        </div>
      </div>
    </section>
  );
};

export default PopularDestinationsSection;
